<script>
	import Logo from "$lib/images/footer_logo.svg"
	import Visa from "$lib/images/visa.svg"
	import Mastercard from "$lib/images/mastercard.svg"
	import ApplePay from "$lib/images/apple-pay.svg"
	import GooglePay from "$lib/images/google-pay.svg"
	import { t, locale } from '$lib/translations';

	const payments = [
		{ name: $t('footer.visa'), image: Visa },
		{ name: $t('footer.mastercard'), image: Mastercard },
		{ name: $t('footer.apple_pay'), image: ApplePay },
		{ name: $t('footer.google_pay'), image: GooglePay }
	]

	const date = new Date()
</script>

<footer>
	<div class="row" id="logo">
		<div class="logo"><img src={Logo} alt="Footer Logo"></div>
		<div class="description">
			{$t('footer.copyright')}
			{date.getFullYear()}
		</div>
	</div>
	<div class="row">
		<div class="title">
			{$t('footer.user')}
		</div>
		<div class="footer-links">
			<ul>
				<li><a href="/{$locale}/privacy-policy">{$t('footer.privacy_policy')}</a></li>
				<li><a href="/{$locale}/user-agreement">{$t('footer.user_agreement')}</a></li>
				<li><a href="/{$locale}/policy-return">{$t('footer.policy_return')}</a></li>
<!--				<li><a href="/#">Про нас</a></li>-->
			</ul>
		</div>
	</div>
	<div class="row">
		<div class="title">
			{$t('footer.main_info')}
		</div>
		<div class="footer-links">
			<ul>
				<li><a href={locale === 'en' || locale === 'ua' ? 'https://forum.unrealrp.com.ua/' : 'https://ge-forum.unrealrp.com/'} target="_blank">{$t('footer.forum')}</a></li>
				<li><a href="/{$locale}/rp">{$t('footer.rp')}</a></li>
			</ul>
		</div>
	</div>
	<div class="row">
		<div class="title">
			{$t('footer.contacts')}
		</div>
		<div class="content">
			<div class="contacts">
				<span>{$t('footer.email')}</span>
			</div>
			<div class="payments">
				{#each payments as payment }
					<div class="payment"><img src={payment.image} alt={payment.image}></div>
				{/each}
			</div>
		</div>
	</div>
</footer>

<style lang="scss">
	@mixin footer-text {
		font-size: 14px;
		line-height: 140%;
		color: #FFFBEF;
		opacity: 0.4;
		font-weight: 300;
		text-decoration: none;
	}

	footer {
		background-color: #161616;
		padding: 30px 100px;
		gap: 40px;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
	}

	#logo {
		gap: 25px;
		width: 350px;
	}

	.row {
		gap: 16px;
		width: max-content;
		display: grid;
		place-content: flex-start;
		//place-self: auto center;

		& > .title {
			font-size: 16px;
			line-height: 140%;
			color: #fffbef;
			font-weight: 400;
			width: max-content;
		}
		& > .logo {
			width: 230px;
		}
		& > .description {
			font-size: 10pt;
			line-height: 140%;
			font-weight: 300;
			color: #FFFBEF;
			opacity: 0.2;
		}
		& > .footer-links {
			width: max-content;

			& > ul {
				list-style-type: none;
				display: flex;
				flex-direction: column;
				gap: 8px;

				& > li {

					& > a {
						@include footer-text;
						transition: opacity 0.3s;

						&:hover {
							opacity: 100%;
						}
					}
				}

			}
		}

		& > .content {
			display: flex;
			flex-direction: column;
			gap: 28px;

			& > .payments {
				display: flex;
				align-items: center;
				gap: 10px;

				& > .payment {

					& > img {
						width: 50px;
					}
				}
			}
			& > .contacts {
				@include footer-text;
			}
		}
	}

	@media screen and (max-width: 1300px) {
		footer {
			padding: 30px;
		}
	}

	@media screen and (max-width: 1150px) {
		footer {
			grid-template-columns: repeat(3, 1fr) !important;
		}
	}

	@media screen and (max-width: 860px) {
		footer {
			grid-template-columns: repeat(2, 1fr) !important;
		}
	}

	@media screen and (max-width: 700px) {
		footer {
			grid-template-columns: repeat(1, 1fr) !important;
		}
		#logo > .logo > img {
			width: 150px;
		}
		#logo {
			width: auto;

			& > .logo > img {
                width: 150px;
            }
		}
	}
</style>